import { useContext, useEffect, useRef, useState } from 'react';
import { FormUtility } from '../../../Utility/FormUtility';
import Input from '../../../Form/Input';
import Select from '../../../Form/Select';
import { useNavigate, useParams } from 'react-router-dom';
import { ComuneService } from '../../../../services/ComuneService';
import { BandoService } from '../../../../services/BandoService';
import ToastContext from '../../../../contexts/toast';
import StatusContext from '../../../../contexts/status';
import { IndirizzoDiStudio } from '../../../../models/IndirizzoDiStudio';
import { Plesso } from '../../../../models/Plesso';
import { IndirizzoStudioService } from '../../../../services/IndirizzoStudioService';
import { PlessoService } from '../../../../services/PlessoService';
import { IstitutoService } from '../../../../services/IstitutoService';

export default function GestioneIndirizzoStudio() {
  const [validate, setValidate] = useState(false);
  const [inputErrors, setInputErrors] = useState(null);

  const [inSave, setInSave] = useState(false);

  const [bando, setBando] = useState(null);

  const [comuni, setComuni] = useState(null);
  const [province, setProvince] = useState(null);

  const [indirizzoDiStudio, setIndirizzoDiStudio] = useState(new IndirizzoDiStudio());
  const [plesso, setPlesso] = useState(new Plesso());
  const [istituto, setIstituto] = useState(new IndirizzoDiStudio());

  const [provincia, setProvincia] = useState(null);

  const ordini = [
    { key: 'I', value: 'Secondaria I° Grado' },
    { key: 'S', value: 'Secondaria II° Grado' }
  ];

  const gestioni = [
    { key: 'STATALE', value: 'Statale' },
    { key: 'PARITARIA', value: 'Paritaria' }
  ];

  const regex = '^(FI|LU|PI|PO|PT|SI|GR|AR|MS|LI)[A-Za-z0-9]{8}$';

  const provinceToscane = new Map([
    ['Arezzo', 'AR'],
    ['Firenze', 'FI'],
    ['Grosseto', 'GR'],
    ['Livorno', 'LI'],
    ['Lucca', 'LU'],
    ['Massa-Carrara', 'MS'],
    ['Pisa', 'PI'],
    ['Pistoia', 'PT'],
    ['Prato', 'PO'],
    ['Siena', 'SI']
  ]);

  const toastContext = useContext(ToastContext);
  const statusContext = useContext(StatusContext);

  const comuneService = new ComuneService();
  const bandoService = new BandoService();
  const plessoService = new PlessoService();
  const istitutoService = new IstitutoService();
  const indirizzoDiStudioService = new IndirizzoStudioService();
  const utility = new FormUtility();

  const params = useParams();
  const navigation = useNavigate();
  const formRef = useRef(null);

  const dataId = params.id ?? null;

  const filtri = utility.getFiltriAvanzatiStorage(null, '_filtri_avanzati', '/gestione-indirizzi-studio');

  useEffect(() => {
    bandoService.getById(filtri.Avviso).then(resp => {
      setBando(resp);
    });

    comuneService.getAllProvinceByRegione('Toscana').then(resp => {
      resp.sort((a, b) => a.value.localeCompare(b.value));
      setProvince(resp);
    });

    if (!dataId) {
      comuneService.getAllByBandoAndTipologiaAndDenominazioneRegioneAndProvincia(filtri.Avviso, 'Comune', 'Toscana', null).then((resp) => {
        resp.sort((a, b) => a.denominazione.localeCompare(b.denominazione));
        setComuni([ ...resp ]);
      });
    } else {
      indirizzoDiStudioService.getByIdForDt(dataId).then(resp => {
        setIstituto({ id: resp.idIstituto, codice: resp.codiceIstituto, denominazione: resp.denominazioneIstituto });
        setPlesso({ id: resp.idPlesso, codice: resp.codicePlesso, denominazione: resp.denominazionePlesso, gestione: resp.gestionePlesso, ordine: resp.ordinePlesso, comune: { id: resp.idComunePlesso, codice: resp.codiceComunePlesso, codiceCatastale: resp.codiceCatastaleComunePlesso, denominazione: resp.denominazioneComunePlesso, denominazioneProvincia: resp.denominazioneProvincia } });
        setIndirizzoDiStudio({ id: resp.idIndirizzo, codice: resp.codiceIndirizzo, denominazione: resp.denominazioneIndirizzo });
        setProvincia(resp.denominazioneProvincia);

        comuneService.getAllByBandoAndTipologiaAndDenominazioneRegioneAndProvincia(filtri.Avviso, 'Comune', 'Toscana', resp.denominazioneProvincia).then((resp) => {
          resp.sort((a, b) => a.denominazione.localeCompare(b.denominazione));
          setComuni([ ...resp ]);
        });
      });
    }

    return () => {
      statusContext.removeEvent('onbeforeunload');
    };
  }, []);

  useEffect(() => {
    if (!validate) {
      return;
    }

    setFormErrors(false);
  }, [provincia, istituto, plesso, indirizzoDiStudio]);

  const onChangeProvincia = (event) => {
    const value = event.target.value;
    if (value) {
      comuneService.getAllByBandoAndTipologiaAndDenominazioneRegioneAndProvincia(filtri.Avviso, 'Comune', 'Toscana', value).then((resp) => {
        resp.sort((a, b) => a.denominazione.localeCompare(b.denominazione));
        setComuni([ ...resp ]);
      });
    } else {
      comuneService.getAllByBandoAndTipologiaAndDenominazioneRegioneAndProvincia(filtri.Avviso, 'Comune', 'Toscana', null).then((resp) => {
        resp.sort((a, b) => a.denominazione.localeCompare(b.denominazione));
        setComuni([ ...resp ]);
      });
    }

    setProvincia(value);

    statusContext.addEvent('onbeforeunload');
    if (validate) {
      setFormErrors(false);
    }
  }

  const onChangeComune = (event) => {
    const value = event.target.value;
    plesso.comune = value ? comuni.find(c => c.id === parseInt(value)) : null;
    setPlesso({  ...plesso });

    statusContext.addEvent('onbeforeunload');
  };

  const onChangeIstituto = async (event, field) => {
    const target = event.target;
    const campo = field ?? target.name;
    const value = target.value;
    istituto[campo] = value;

    if (campo === 'codice') {
      if (value.length === 10) {
        const resp = await istitutoService.findByCodice(value);
        istituto.id = resp.id;
        istituto.denominazione = resp.denominazione;
      } else {
        istituto.id = null;
      }
    }

    setIstituto({ ...istituto });

    statusContext.addEvent('onbeforeunload');
  };

  const onChangePlesso = async (event, field) => {
    const target = event.target;
    const campo = field ?? target.name;
    const value = target.value;
    plesso[campo] = value;

    switch (campo) {
      case 'ordine':
        if (value === 'I') {
          indirizzoDiStudio.codice = null;
          indirizzoDiStudio.denominazione = null;
          setIndirizzoDiStudio({ ...indirizzoDiStudio });
        }
        break;
      case 'codice':
        if (value.length === 10) {
          const resp = await plessoService.findByCodice(value);
          plesso.id = resp.id;
          plesso.denominazione = resp.denominazione;
          plesso.ordine = resp.ordine;
        } else {
          plesso.id = null;
        }
        break;
      default:
        break;
    }

    setPlesso({ ...plesso });

    statusContext.addEvent('onbeforeunload');
  };

  const onChangeIndirizzo = async (event, field) => {
    const target = event.target;
    const campo = field ?? target.name;
    const value = target.value;
    indirizzoDiStudio[campo] = value;

    if (campo === 'codice') {
      if (value.length === 4) {
        const resp = await indirizzoDiStudioService.findByCodice(value);
        indirizzoDiStudio.id = resp.id;
        indirizzoDiStudio.denominazione = resp.denominazione;
      } else {
        indirizzoDiStudio.id = null;
      }
    }

    setIndirizzoDiStudio({ ...indirizzoDiStudio });

    statusContext.addEvent('onbeforeunload');
  };

  const setFormErrors = (setFocus = true) => {
    const errors = utility.getAllInputErrors(formRef);
    setInputErrors(errors.map((el) => el.id));
    if (setFocus && errors.length > 0) {
      errors[0].focus();
    }
  };

  const denyOperation = () => {
    navigation('/gestione-indirizzi-studio');
  };

  const sendData = (event) => {
    event.preventDefault();
    event.stopPropagation();

    setValidate(true);

    const validity = formRef.current.checkValidity();
    if (!validity) {
      setFormErrors();
      return;
    }

    setInSave(true);

    setInputErrors([]);

    istituto.codice = istituto.codice.toUpperCase();
    istituto.bando = bando;
    plesso.codice = plesso.codice.toUpperCase();
    plesso.bando = bando;
    plesso.istituto = istituto;
    indirizzoDiStudio.bando = bando;
    indirizzoDiStudio.plesso = plesso;

    const service = dataId ? indirizzoDiStudioService.update : indirizzoDiStudioService.create;
    service(indirizzoDiStudio)
      .then(() => {
        toastContext.success(
          'Indirizzo di studio ' + (dataId ? 'aggiornato' : 'aggiunto') + ' con successo!'
        );
        statusContext.removeEvent('onbeforeunload');

        setTimeout(() => {
          navigation('/gestione-indirizzi-studio');
        }, 100);

        setInSave(false);
      })
      .catch((error) => {
        toastContext.error(utility.getErrorMsg(error), 12000);
        setInSave(false);
      });
  };

  return (
    <div className='rtds-container rtds-my-12 '>
      <div className='rtds-mb-6'>
        <h1 className='rtds-text-2xl rtds-font-bold'>
          {dataId
            ? 'Modifica Indirizzo di studio'
            : 'Inserimento Indirizzo di studio'}
        </h1>
      </div>
      <div className='rtds-background-01 rtds-p-6 rtds-border rtds-border-gray-02'>
        <div className='rtds-pb-6 rtds-space-y-4 rtds-border-b rtds-border-gray-02'>
          <p>
            I campi obbligatori sono contrassegnati da un asterisco&nbsp;
            <abbr
              className='rtds-font-bold rtds-no-underline'
              title='obbligatorio'
            >
              *
            </abbr>
          </p>
        </div>

        <form
          noValidate
          ref={formRef}
          id='hasValidationForm'
          className='has-js-validation-form rtds-py-6 rtds-space-y-4'
          onSubmit={sendData}
        >
          <div className='rtds-field-row'>
            <Select
              classDiv={'rtds-mt-3 lg:rtds-mt-0'}
              label={'Provincia'}
              required
              id={'provincia'}
              inputErrors={inputErrors}
              classSelect={''}
              onChange={(event) => onChangeProvincia(event)}
              baseOption={'Seleziona Provincia'}
              options={province}
              bindValue={'key'}
              value={provincia || ''}
            />

            <Select
              classDiv={'rtds-mt-3 lg:rtds-mt-0'}
              label={'Comune'}
              required
              id={'comune'}
              inputErrors={inputErrors}
              onChange={(event) => onChangeComune(event)}
              baseOption={'Seleziona Comune'}
              options={comuni}
              bindKey={'id'}
              bindValue={'denominazione'}
              value={plesso.comune?.id || ''}
            />
          </div>
          <div className='rtds-field-row'>
            <Input
              label={'Codice istituzione scolastica'}
              required
              id={'codIstituzioneScolastica'}
              inputErrors={inputErrors}
              classInput={'rtds-text-sm rtds-input-placeholder rtds-pr-12'}
              type={'text'}
              onChange={(event) => onChangeIstituto(event, 'codice')}
              value={istituto.codice ? istituto.codice.toUpperCase() : ''}
              pattern={regex}
              otherField={provincia}
              otherFields={provinceToscane}
              customValidationMessage={'Il codice meccanografico non è conforme alla provincia selezionata'}
              errorPattern={'Il codice meccanografico non fa riferimento ad una provincia della Toscana'}
              errorOtherField={'Il codice meccanografico non è conforme con la provincia selezionata'}
              minLenght={10}
              maxLength={10}
            />

            <Input
              label={'Denominazione istituzione scolastica'}
              required
              id={'denominazioneIstituzioneScolastica'}
              inputErrors={inputErrors}
              classInput={'rtds-text-sm rtds-input-placeholder rtds-pr-12'}
              type={'text'}
              onChange={(event) => onChangeIstituto(event, 'denominazione')}
              value={istituto.denominazione || ''}
              maxLength={75}
            />
          </div>

          <div className='rtds-field-row'>
            <Input
              label={'Codice plesso'}
              required
              id={'codPlesso'}
              inputErrors={inputErrors}
              classInput={'rtds-text-sm rtds-input-placeholder rtds-pr-12'}
              type={'text'}
              onChange={(event) => onChangePlesso(event, 'codice')}
              value={plesso.codice ? plesso.codice.toUpperCase() : ''}
              pattern={regex}
              otherField={provincia}
              otherFields={provinceToscane}
              errorPattern={'Il codice meccanografico non fa riferimento ad una provincia della Toscana'}
              errorOtherField={'Il codice meccanografico non è conforme con la provincia selezionata'}
              minLenght={10}
              maxLength={10}
            />

            <Input
              label={'Denominazione plesso'}
              required
              id={'denominazionePlesso'}
              inputErrors={inputErrors}
              classInput={'rtds-text-sm rtds-input-placeholder rtds-pr-12'}
              type={'text'}
              onChange={(event) => onChangePlesso(event, 'denominazione')}
              value={plesso.denominazione || ''}
              maxLength={75}
            />
          </div>
          <div className='rtds-field-row'>
            <Select
              classDiv={'rtds-mt-3 lg:rtds-mt-0'}
              label={'Gestione'}
              required
              id={'gestione'}
              inputErrors={inputErrors}
              onChange={(event) => onChangePlesso(event)}
              baseOption={'Seleziona Gestione'}
              options={gestioni}
              bindValue={'value'}
              bindKey={'key'}
              value={plesso.gestione || ''}
            />

            <Select
              classDiv={'rtds-mt-3 lg:rtds-mt-0'}
              label={'Ordine e grado'}
              required
              id={'ordine'}
              inputErrors={inputErrors}
              onChange={(event) => onChangePlesso(event)}
              baseOption={'Seleziona ordine e grado'}
              options={ordini}
              bindValue={'value'}
              bindKey={'key'}
              value={plesso.ordine || ''}
              disabled={plesso.id}
            />
          </div>
          <div className='rtds-field-row'>
            <Input
              label={'Codice indirizzo di studio'}
              required
              id={'codIndirizzoStudio'}
              inputErrors={inputErrors}
              classInput={'rtds-text-sm rtds-input-placeholder rtds-pr-12'}
              type={'text'}
              onChange={(event) => onChangeIndirizzo(event, 'codice')}
              value={indirizzoDiStudio.codice || ''}
              maxLength={4}
              disabled={plesso.ordine === 'I'}
            />

            <Input
              label={'Denominazione indirizzo di studio'}
              required
              id={'denominazioneIndirizzoStudio'}
              inputErrors={inputErrors}
              classInput={'rtds-text-sm rtds-input-placeholder rtds-pr-12'}
              type={'text'}
              onChange={(event) => onChangeIndirizzo(event, 'denominazione')}
              value={indirizzoDiStudio.denominazione || ''}
              maxLength={100}
              disabled={plesso.ordine === 'I'}
            />
          </div>

          <div className='rtds-border-gray-02 rtds-border-b rtds-border-t rtds-p-3 rtds-flex sm:justify-end justify-center'>
            <div className='rtds-form-actions'>
              <div
                className='rtds-inline-flex rtds-gap-1'
                role='group'
                aria-label='Azioni'
              >
                <button
                  type='button'
                  className='rtds-btn rtds-btn--secondary rtds-form-submit rtds-btn--icon-left rtds-group/button'
                  onClick={() => denyOperation()}
                  disabled={inSave}
                >
                  <svg
                    className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6  group-hover/button:-rtds-translate-x-1'
                    aria-hidden='true'
                    focusable='false'
                    role='img'
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#solid--arrow-uturn-left`}
                    />
                  </svg>
                  Annulla
                </button>
                <button
                  type='submit'
                  className='rtds-btn rtds-btn--primary rtds-form-submit rtds-btn--icon-right rtds-group/button'
                  disabled={inSave}
                >
                 
                  {dataId ? 'Salva' : 'Salva'}
                  <svg
                    className='rtds-icon rtds-fill-current rtds-w-6 rtds-h-6 group-hover/button:-rtds-translate-x-1'
                    aria-hidden='true'
                    focusable='false'
                    role='img'
                  >
                    <use
                      xlinkHref={`${process.env.PUBLIC_URL}/icons.svg#${
                        dataId ? 'solid--chevron-right' : 'solid--chevron-right'
                      }`}
                    />
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}
